import styled from "styled-components";

import { Grid, } from "@bracket/ui";

import { getAccount } from "wagmi/actions";
import { wagmiConfig } from "@wagmiconfig";
import { TextInput } from "@components";
import { FieldDescription } from "./FieldDescription";
import { VerificationField } from "./VerificationField";



export declare type FormFieldsProps = {
	formData: {
		name: string;
		nickname: string;
		email: string;
	};
	onFieldChange: (field: string, value: string) => void;
	onFieldBlur: (field: string, value: string) => void;
	errors: {
		name?: string;
		nickname?: string;
		email?: string;
	};
}

const isDefaultEmail = (value: string): boolean => {
	const { address } = getAccount(wagmiConfig);
	return value.toLowerCase() === `${address}@bracket.fi`.toLowerCase();
};

export const FormFields: React.FC<FormFieldsProps> = ({
	formData,
	onFieldChange,
	onFieldBlur,
	errors,
}) => {
	return (
		<Container>

			<FieldContainer>
				<FieldDescription title="Legal Name" />
				<TextInput
					value={formData.name}
					onChange={(value) => onFieldChange("name", value)}
					onBlur={() => onFieldBlur("name", formData.name)}
					placeholder="My full name"
					error={errors.name}
				/>
			</FieldContainer>

			<FieldContainer>
				<FieldDescription title="Nickname" description="" />
				<TextInput
					value={formData.nickname}
					onChange={(value) => onFieldChange("nickname", value)}
					onBlur={() => onFieldBlur("nickname", formData.nickname)}
					showIcon
					placeholder="Unique nickname like mikea8b4"
					error={errors.nickname}
				/>
			</FieldContainer>

			<FieldContainer>
				<FieldDescription title="Email" description="" />
				<TextInput
					value={isDefaultEmail(formData.email) ? "" : formData.email}
					onChange={(value) => onFieldChange("email", value)}
					onBlur={() => onFieldBlur("email", formData.email)}
					placeholder="Email address"
					error={errors.email}
				/>
			</FieldContainer>

			<FieldContainer>
				<VerificationField />
			</FieldContainer>

			{/* <DisconnectBtn
				label={<Typography variant="paragraphMD">Disconnect</Typography>}
				variant="secondary"
				size="md"
				icon={"Leading"}
				iconProps={{
					style: { height: "20px", fill: "var(--on-surface-variant)" },
				}}
			/> */}
		</Container>
	);
};



const Container = styled(Grid)`
	display: grid;
	grid-template-columns: 1fr;
	gap: 32px;

	@media (min-width: 768px) {
		grid-template-columns: 1fr 1fr;
	}
`;

const FieldContainer = styled(Grid)`
	display: grid;
	gap: 16px;
	grid-template-columns: 1fr;

	@media (min-width: 768px) {
		grid-template-columns: 1fr 1fr;
		gap: 32px;
		grid-column: 2 span;
	}
`;

// const DisconnectBtn = styled(Button)`
// 	border: 1px solid var(--surface-container-highest);
// 	background-color: transparent;
// 	color: var(--on-surface-variant);
// 	width: fit-content;
// `;
